import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AYMING_BLUE = '#00aeef';

const CompanyV2Header = ({ company, accountType, activeTab }) => {
  const { t } = useTranslation();

  const tabs = [
    { key: 'overview',  label: t('overview')  || 'Overview',  path: `/${accountType}/companies/${company.id}/overview` },
    { key: 'settings',  label: t('settings')  || 'Settings',  path: `/${accountType}/companies/${company.id}/edit` },
    { key: 'documents', label: t('documents') || 'Documents', path: `/${accountType}/companies/${company.id}/documents` },
  ];

  const showAddClaimGroup =
    activeTab === 'overview' &&
    window.MARKET_CONSTANTS?.SHOW_ADD_CLAIM_GROUP_BTN_ON_MASTER_PAGE;

  return (
    <div style={{ maxWidth: '95%', margin: '0 auto', padding: '1.5rem 3rem 0' }}>
      <div className="d-flex align-items-center justify-content-between mb-3 mt-3">
        <h1 className="fw-bold mb-0" style={{ color: '#0078B9' }}>{company.name}</h1>

        {showAddClaimGroup && (
          <Link
            to={`/${accountType}/companies/add_claim_group/${company.id_in_provider_system}--${company.number}/companies/${company.id}`}
            style={{
              background: AYMING_BLUE,
              color: '#fff',
              borderRadius: '24px',
              padding: '10px 22px',
              fontSize: '14px',
              fontWeight: 500,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}
          >
            <span className="material-icons" style={{ fontSize: '18px' }}>add</span>
            {t('add')} {t('claim_group')}
          </Link>
        )}
      </div>

      <Nav variant="tabs" className="mb-0">
        {tabs.map(tab => (
          <Nav.Item key={tab.key}>
            <Nav.Link
              as={Link}
              to={tab.path}
              active={activeTab === tab.key}
              className="fw-semibold"
            >
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default CompanyV2Header;
